{
  "$schema": "https://json.schemastore.org/package.json",
  "name": "nexus-app",
  "main": "expo-router/entry",
  "version": "1.16.1",
  "type": "module",
  "scripts": {
    "setup": "tsx scripts/dev-setup.ts",
    "stop": "tsx scripts/dev-stop.ts",
    "all-start": "tsx scripts/dev-all-start.ts",
    "all-stop": "tsx scripts/dev-all-stop.ts",
    "all-status": "tsx scripts/dev-all-status.ts",
    "sync-edge-secrets": "tsx scripts/sync-edge-secrets.ts",
    "cloc": "cloc src scripts supabase/tests .eas .github",
    "seed:dump": "supabase db dump --local --data-only --schema auth -x auth.audit_log_entries,auth.sessions,auth.refresh_tokens,auth.mfa_amr_claims,auth.mfa_factors,auth.mfa_challenges,auth.flow_state,auth.one_time_tokens,auth.schema_migrations -f supabase/seed_auth.sql && supabase db dump --local --data-only --schema public -f supabase/seed_public.sql && supabase db dump --local --data-only --schema link -f supabase/seed_link.sql && supabase db dump --local --data-only --schema lists -f supabase/seed_lists.sql && supabase db dump --local --data-only --schema comments -f supabase/seed_comments.sql && supabase db dump --local --data-only --schema history -f supabase/seed_history.sql",
    "seed:adduser": "tsx scripts/seed-adduser.ts",
    "start": "bash scripts/assert-expo-port-free.sh && npx env-cmd -f .env.local expo start --dev-client -c --localhost --port 8081",
    "start:tunnel": "npx env-cmd -f .env.local expo start --dev-client -c --tunnel",
    "export:dev": "npx env-cmd -f .env.development expo export --platform web -c -s",
    "deploy:preview": "npx env-cmd -f .env.development expo export --platform web -c -s && npx env-cmd -f .env.development eas deploy --alias=preview --environment=preview",
    "deploy:prod": "npx env-cmd -f .env.production expo export --platform web -c -s && npx env-cmd -f .env.production eas deploy --prod --environment=production",
    "test": "jest --watch",
    "test:ci": "jest --ci --runInBand --watchAll=false",
    "test:coverage": "jest --coverage --watchAll=false --maxWorkers=2",
    "test:update": "jest --updateSnapshot --watchAll=false",
    "lint": "eslint . --ext .ts,.tsx",
    "typecheck": "tsc --noEmit",
    "upload:srcmap": "npx sentry-expo-upload-sourcemaps dist",
    "lint:eslint": "eslint . --ext .ts,.tsx",
    "prepare": "node -e \"process.env.NODE_ENV === 'development' && require('child_process').execSync('husky', { stdio: 'inherit' })\""
  },
  "jest": {
    "preset": "jest-expo",
    "setupFilesAfterEnv": [
      "<rootDir>/scripts/test-setup.ts"
    ],
    "moduleNameMapper": {
      "^@/(.*)$": "<rootDir>/src/$1"
    },
    "transformIgnorePatterns": [
      "/node_modules/(?!((jest-)?react-native|@react-native(-community)?)|expo(nent)?|@expo(nent)?/.*|@expo-google-fonts/.*|react-navigation|@react-navigation/.*|@sentry/react-native|native-base|react-native-svg|color|color-string|color-convert|color-name|simple-swizzle|is-arrayish)",
      "/node_modules/react-native-reanimated/plugin/"
    ],
    "collectCoverageFrom": [
      "src/**/*.{ts,tsx}",
      "!src/**/*.d.ts",
      "!src/**/__tests__/**",
      "!scripts/test-setup.ts"
    ]
  },
  "dependencies": {
    "@expo/config-types": "^52.0.5",
    "@expo/ngrok": "^4.1.3",
    "@expo/vector-icons": "~14.0.4",
    "@react-native-async-storage/async-storage": "1.23.1",
    "@react-navigation/bottom-tabs": "^7.2.0",
    "@react-navigation/drawer": "^7.1.1",
    "@react-navigation/material-top-tabs": "^7.3.7",
    "@react-navigation/native": "^7.0.14",
    "@react-navigation/stack": "^7.6.13",
    "@rneui/themed": "^4.0.0-rc.8",
    "@sentry/react-native": "~6.10.0",
    "@supabase/supabase-js": "^2.49.4",
    "@twilio/voice-react-native-sdk": "^1.7.0",
    "@twilio/voice-sdk": "^2.16.0",
    "@types/lodash-es": "^4.17.12",
    "babel-plugin-react-compiler": "^19.0.0-beta-af1b7da-20250417",
    "color": "^5.0.0",
    "date-fns": "^4.1.0",
    "date-fns-tz": "^3.2.0",
    "dom-to-image": "^2.6.0",
    "dotenv": "^16.5.0",
    "eslint-plugin-tsdoc": "^0.4.0",
    "expo": "~52.0.49",
    "expo-application": "~6.0.2",
    "expo-audio": "~0.3.5",
    "expo-barcode-generator": "^4.0.0",
    "expo-blur": "~14.0.3",
    "expo-build-properties": "~0.13.3",
    "expo-checkbox": "~4.0.1",
    "expo-clipboard": "~7.0.1",
    "expo-constants": "~17.0.8",
    "expo-crypto": "~14.0.2",
    "expo-dev-client": "~5.0.20",
    "expo-device": "~7.0.3",
    "expo-document-picker": "~13.0.3",
    "expo-font": "~13.0.4",
    "expo-haptics": "~14.0.1",
    "expo-image": "~2.0.7",
    "expo-image-picker": "~16.0.6",
    "expo-insights": "~0.8.2",
    "expo-linear-gradient": "~14.0.2",
    "expo-linking": "~7.0.5",
    "expo-media-library": "~17.0.6",
    "expo-router": "~4.0.22",
    "expo-screen-orientation": "~8.0.4",
    "expo-secure-store": "~14.0.1",
    "expo-splash-screen": "~0.29.24",
    "expo-status-bar": "~2.0.1",
    "expo-symbols": "~0.2.2",
    "expo-system-ui": "~4.0.9",
    "expo-updates": "^0.27.5",
    "expo-web-browser": "~14.0.2",
    "jiti": "^2.4.2",
    "jwt-decode": "^4.0.0",
    "lodash-es": "^4.17.21",
    "react": "18.3.1",
    "react-compiler-runtime": "^19.0.0-beta-af1b7da-20250417",
    "react-dom": "18.3.1",
    "react-native": "0.76.9",
    "react-native-dotenv": "^3.4.11",
    "react-native-gesture-handler": "~2.20.2",
    "react-native-markdown-display": "^7.0.2",
    "react-native-mmkv": "^3.2.0",
    "react-native-pager-view": "6.5.1",
    "react-native-pdf": "^6.7.7",
    "react-native-qrcode-svg": "^6.3.21",
    "react-native-reanimated": "~3.16.1",
    "react-native-safe-area-context": "4.12.0",
    "react-native-screens": "~4.4.0",
    "react-native-svg": "15.8.0",
    "react-native-url-polyfill": "^2.0.0",
    "react-native-view-shot": "~4.0.3",
    "react-native-web": "~0.19.13",
    "react-native-webview": "13.12.5",
    "react-pdf": "^10.1.0",
    "react-refresh": "^0.17.0",
    "ts-node": "^10.9.2",
    "twilio": "^5.7.2",
    "zod": "^3.24.2"
  },
  "devDependencies": {
    "@babel/core": "^7.26.10",
    "@babel/plugin-transform-class-static-block": "^7.28.3",
    "@babel/preset-typescript": "^7.27.0",
    "@commitlint/cli": "^19.8.0",
    "@commitlint/config-conventional": "^19.8.0",
    "@eslint/compat": "^1.0.3",
    "@eslint/js": "^9.24.0",
    "@semantic-release/changelog": "^6.0.3",
    "@semantic-release/git": "^10.0.1",
    "@semantic-release/github": "^11.0.2",
    "@testing-library/jest-native": "^5.4.3",
    "@testing-library/react-native": "^13.3.3",
    "@testing-library/user-event": "^14.6.1",
    "@types/dom-to-image": "^2.6.7",
    "@types/jest": "^29.5.14",
    "@types/pg": "^8.11.11",
    "@types/react": "~18.3.12",
    "@types/react-test-renderer": "^18.3.0",
    "@typescript-eslint/eslint-plugin": "^8.29.1",
    "@typescript-eslint/parser": "^8.30.1",
    "autoprefixer": "^10.4.20",
    "babel-plugin-module-resolver": "^5.0.2",
    "baseline-browser-mapping": "^2.10.38",
    "eslint": "^9.25.0",
    "eslint-config-expo": "^9.2.0",
    "eslint-config-prettier": "^10.1.2",
    "eslint-plugin-jsdoc": "^50.6.9",
    "eslint-plugin-prettier": "^5.2.6",
    "eslint-plugin-react": "^7.37.5",
    "globals": "^16.0.0",
    "husky": "^9.1.7",
    "jest": "~29.7.0",
    "jest-environment-jsdom": "^29.7.0",
    "jest-expo": "~52.0.6",
    "lint-staged": "^16.0.0",
    "p-map": "^7.0.3",
    "pg": "^8.14.1",
    "postcss": "^8.4.49",
    "postgres": "^3.4.5",
    "prettier": "^3.5.3",
    "react-test-renderer": "18.3.1",
    "semantic-release": "^24.2.3",
    "supabase": "2.107.0",
    "tailwindcss": "^3.4.17",
    "tsc-files": "^1.1.4",
    "tsx": "^4.19.4",
    "typescript": "^5.3.3",
    "typescript-eslint": "^8.30.1",
    "zod-to-json-schema": "^3.24.5"
  },
  "lint-staged": {
    "*.{ts,tsx}": [
      "eslint  --fix"
    ]
  },
  "private": true,
  "expo": {
    "install": {
      "exclude": [
        "eslint-config-expo"
      ]
    },
    "doctor": {
      "reactNativeDirectoryCheck": {
        "exclude": [
          "eslint-config-expo",
          "ts-node",
          "jwt-decode",
          "dom-to-image",
          "dotenv",
          "eslint-plugin-tsdoc",
          "jiti",
          "@rneui/themed",
          "lodash-es",
          "react-refresh",
          "expo-checkbox",
          "zod",
          "twilio",
          "color",
          "react-pdf",
          "pdfjs-dist",
          "react-native-markdown-display",
          "react-native-dotenv",
          "@twilio/voice-sdk",
          "date-fns-tz",
          "expo-barcode-generator"
        ]
      }
    }
  }
}
